import { UserRole } from '../interfaces';

export function userIsKioskRole(userRole?: UserRole | null): boolean {
  return userRole === UserRole.Kiosk;
}

export function userIsSuperAdminRole(userRole?: UserRole | null): boolean {
  return userRole === UserRole.SuperAdmin;
}
